import { render, staticRenderFns } from "./DisabledView.vue?vue&type=template&id=0b1ac2c6&scoped=true&"
import script from "./DisabledView.vue?vue&type=script&lang=js&"
export * from "./DisabledView.vue?vue&type=script&lang=js&"
import style0 from "./DisabledView.vue?vue&type=style&index=0&id=0b1ac2c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ac2c6",
  null
  
)

export default component.exports